<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Enregistrement du filtre</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <div class="form-item">
                <mat-form-field class="mat-form-field-name">
                    <mat-label>Nom du filtre</mat-label>
                    <input
                        matInput
                        appOnKeyEnterEvent
                        (enter)="validate()"
                        [formControl]="nameFormControl"
                        [(ngModel)]="dialogSavePredefinedFilterData.predefinedFilter.name"
                        autocomplete="off"
                        required />
                    @if (nameFormControl.hasError('required') && (nameFormControl?.dirty || nameFormControl?.touched)) {
                        <mat-error>Le nom est obligatoire</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-checkbox class="primary-button" matInput [formControl]="sharedFormControl" [(ngModel)]="dialogSavePredefinedFilterData.predefinedFilter.shared">
                    Partager le filtre.
                </mat-checkbox>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" [mat-dialog-close]="dialogSavePredefinedFilterData.predefinedFilter" [disabled]="!nameFormControl.valid">
            Enregistrer
        </button>
    </mat-card-actions>
</mat-card>
